export default {
  BASE_STORAGE: process.env.REACT_APP_BASE_STORAGE,
  BASE_API: process.env.REACT_APP_BASE_API,
  BASE_PUBLIC: process.env.REACT_APP_BASE_PUBLIC,
  TIMEZONE: 'America/Caracas',
  LEVELS: {
    ADMIN: 1,
    MODERATOR: 2,
    CLIENT: 3,
    LAWYER: 4,
  },
  USER_STATUS: {
    ACTIVE: 1,
    INACTIVE: 0,
  },
  USER: {
    VERIFIED: {
      PENDING: 0,
      APPROVED: 1,
      REJECTED: 2,
    },
    STATUS: {
      PENDING: 0,
      ACTIVE: 1,
      INACTIVE: 2,
    },
  },
  CHAT_STATUS: {
    ACTIVE: 1,
    INACTIVE: 0,
  },
  CHAT_TYPE: {
    CLIENT_LAWYER: 1,
    LAWYER_LAWYER: 2,
    CLIENT_LAWYER_WITH_FILES: 3,
    LAWYER_COMMUNITY: 4,
  },
  MODULES: {
    USERS: 1,
    SERVICES: 2,
    MEMBERSHIPS: 3,
    FORMALITIES: 4,
    REVISION: 5,
    SIGNATURE: 6,
    RATINGS: 7,
    GUIDES: 8,
    CHAT: 9,
    REPORTS: 10,
    CALLS: 11,
    DOCUMENTS: 12,
    PREPARATION: 13,
    // ⚠️ Confirmar con backend el ID real asignado a esta fila en la tabla Modules.
    NOTIFICATIONS: 14,
  },
  NOTIFICATION_SEGMENT_TYPE: {
    CUSTOM: 'custom',
    ALL_CLIENTS: 'all_clients',
    ALL_LAWYERS: 'all_lawyers',
  },
  // Catálogo de guides_types. YOUTUBE es el tipo especial que activa el
  // flujo de link de YouTube en vez de archivo/área en el formulario de
  // creación de guías. Debe coincidir con Constants.GUIDE_TYPES del
  // backend (src/utils/constants.ts en Legalmente-Api).
  GUIDE_TYPES: {
    DOCUMENT: 1,
    YOUTUBE: 2,
  },
  PRICE_STATUS: {
    YES: 1,
    NO: 0,
  },
  DOCUMENT_TYPES: {
    V: 1,
    E: 2,
    J: 3,
    G: 4,
  },
  VERIFIED: {
    PENDING: 0,
    IN_PROCESS: 1,
    VERIFIED: 2,
    REJECTED: 3,
  },
  LAWYER_INTERNAL: {
    YES: 1,
    NO: 0,
  },
  RESERVED_TAGS: {
    NAME: 1,
    LASTNAME: 2,
    DOCUMENT: 3,
  },
  REVISION_STATUS: {
    PENDING: 0,
    ACCEPTED: 1,
    REJECTED: 2,
    NO_TAKEN: 3,
    FINISHED: 4,
    SEARCHING: 5,
    CANCELLED: 6,
  },
  PREPARATION_STATUS: {
    PENDING: 0,
    FINISHED: 1,
  },
  SIGNATURE_STATUS: {
    PENDING: 0,
    ACCEPTED: 1,
    REJECTED: 2,
  },
  // Espejo de Constants.SIGNATURE_SIGNER_STATUS del backend (firmantes
  // invitados en signature_signers, feature "invitar firmantes").
  SIGNATURE_SIGNER_STATUS: {
    PENDING: 0,
    ACTIVE: 1,
    SIGNED: 2,
    REJECTED: 3,
  },
  PAYMENT_METHODS: {
    PAYMENT_MOBILE: 1,
    STRIPE: 2,
    SYPAGO: 3,
  },
  PLAN_PAYMENT_MODES: {
    MONTH: 1,
    YEAR: 2,
  },
  SERVICES: {
    SIGN: 1,
    CALL: 2,
    REVISION: 3,
    FORMALITIES: 4,
    PREPARATION: 5,
    CHAT: 6,
    BOTPRESS_CHAT: 7,
    LAWYER_DIRECTORY: 8,
    CIVIL_AND_PROFESSIONAL_LIABILITY_INSURANCE: 9,
    COWORKING: 10,
    BUSINESS_LOUNGE: 11,
  },
  ACCOUNT_TYPES: {
    SAVING: 1,
    CHECKING: 2,
  },
  UNLIMITED: {
    YES: 1,
    NO: 0,
  },
  CALL_STATUS: {
    PENDING: 1,
    RESOLVED: 2,
    NO_RESOLVED: 3,
    RE_SCHEDULED: 4,
    REVIEW: 5,
    IN_PROCESS: 6,
    CANCELLED: 7,
  },
  CHAT_RESOLVED_STATUS: {
    PENDING: 1,
    RESOLVED: 2,
    NO_RESOLVED: 3,
    REVIEW: 4,
    IN_PROCESS: 5,
  },
  ACCES_STATUS: {
    ACCESS_GRANTED: 1,
    ACCESS_LIMITED: 2,
    ACCESS_DENIED: 3,
  },
  SEARCH_PREPARATION_STATUS: {
    IN_SEARCH: 1,
    WAITING_FOR_USER_RESPONSE: 2,
    FINISHED: 3,
  },
  // DEV-LT-35: estados de la búsqueda de abogado externo para Revisión Documental.
  // Mirror exacto de SEARCH_PREPARATION_STATUS de arriba (mismos 3 valores) --
  // antes de este cambio la Web no tenía este bloque, aunque el backend y la app
  // móvil ya lo usaban (Constants.SEARCH_REVISION_STATUS en Legalmente-Mobile-App).
  SEARCH_REVISION_STATUS: {
    IN_SEARCH: 1,
    WAITING_FOR_USER_RESPONSE: 2,
    FINISHED: 3,
  },
  CHAT_STATUS_PAYMENT: {
    YES: 1,
    NO: 0,
  },
  TAXES: {
    IVA: 16,
    IGTF: 3,
  },
  // Espejo de Constants.REFERRAL_WITHDRAWAL_STATUS del backend
  // (Legalmente-Api/src/utils/constants.ts).
  REFERRAL_WITHDRAWAL_STATUS: {
    PENDING: 1,
    PAID: 2,
    REJECTED: 3,
  },
  // Espejo de Constants.REFERRAL_MOVEMENT_TYPES del backend.
  REFERRAL_MOVEMENT_TYPES: {
    EARNED_FIRST_PURCHASE: 1,
    EARNED_RENEWAL: 2,
    WITHDRAWAL: 3,
  },
};
